module.exports = __webpack_public_path__ + "img/pr_help1.fd8c2b41.png";